import { Card, Table } from "react-bootstrap"
import Affiliate from "../../../templates/Affiliate/Affiliate"
import { DollarSign } from "react-feather"
import Dollars from "../../../templates/Dollars/Dollars"
import ReportsMoreAvatar from "../AvatarReports/AvatarReportsMore/AvatarReportsMore"
import useCallApi from "../../../hooks/useCallApi"
import Loading from "../../../templates/UI/Loading/Loading"
import { Link } from "react-router-dom/cjs/react-router-dom.min"

const TopAffiliate = ({ title, type, startDate, endDate, order }) => {

    const { data, dataLoaded } = useCallApi(`reports/avatar/affiliate?startDate=${startDate}&endDate=${endDate}`, 'GET', {}, [])

    return (
        <Card className="mt-3">
            <Card.Header className='d-flex align-items-center justify-content-between'>
                <h1 className="mb-h1-dark">{title}</h1>
                <div><Link to={`/avatar/reports/affiliate?startDate=${startDate}&endDate=${endDate}`}>Full Report</Link></div>
            </Card.Header>
            <Card.Body className="p-0">
                <Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Affiliate</th>
                            <th className="text-right">Cost</th>
                            <th className="text-right">Revenue</th>
                            <th className="text-right">Margin</th>
                            <th className="text-right" />

                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ?
                            data.report.length > 0 ?
                                data.report
                                    .sort((a, b) => {
                                        if (order === 'desc') {
                                        return b[type] - a[type]
                                    }
                                    return a[type] - b[type]
                                })
                                .map((item, index) => {
                                    if (index < 10) {
                                        return (
                                            <tr key={item.affiliate.id}>
                                                <td>{item.affiliate.id}</td>
                                                <td><Affiliate name={item.affiliate.name} aid={item.affiliate.id} status={item.affiliate.status} priority={item.affiliate.priority} offerStatus={item.affiliate.offerStatus} /></td>
                                                <td align="right"><Dollars value={item.cost} /></td>
                                                <td align="right"><Dollars value={item.revenue} /></td>
                                                <td align="right"><Dollars value={item.margin} /></td>
                                                <td align="right"><ReportsMoreAvatar avatarAffiliateSummaryReport avatarDailyReport avatarPropertyReport avatarOfferReport avatarSurveyQuestionReport avatarSurveyResponseReport subid avatarConversionReport avatarEventReport avatarSetReport affiliateId={item.affiliate.id} startDate={startDate} endDate={endDate} /></td>
                                            </tr>
                                        )
                                    }
                                })
                            :
                                <tr>
                                    <td colSpan="6" className="text-center">No data found</td>
                                </tr>
                        :
                            <tr>
                                <td colSpan="6" className="text-center"><Loading /></td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </Card.Body>

        </Card>
    )
}

export default TopAffiliate
